<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader class="object-header">
            <CRow>
                <CCol>
                    <h1 class="page__title">
                        {{ $t(titlePage) }}
                    </h1>
                </CCol>
                <CCol>
                    <ButtonCreate
                        @click="
                            $router.push({
                                name: 'create_client',
                            })
                        "
                    >
                        {{ $t("create_client") }}
                    </ButtonCreate>
                </CCol>
                <!-- Title page  -->
            </CRow>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid class="p-0">
                <CRow class="p-2 m-0">
                    <CCol md="12" sm="12">
                        <!-- Filter -->
                        <FilterFields
                            :fields="tables.clients_data.fields"
                            @filter="updateData"
                        />
                    </CCol>
                </CRow>
                <CRow
                    v-show="
                        hasItemsInTable({
                            tableName: 'clients_data',
                        })
                    "
                >
                    <CCol xl="12" md="12" class="mb-4">
                        <CCard>
                            <CCardHeader>
                                <!-- Button back -->
                                <div class="d-flex">
                                    <TableSettings
                                        :allFields="
                                            tables.clients_data.allFields
                                        "
                                        :activeFields.sync="
                                            tables.clients_data.fields
                                        "
                                    />
                                </div>
                            </CCardHeader>
                            <CCardBody>
                                <CCTable
                                    :addTableClasses="['table--sm']"
                                    :items="tables.clients_data.items"
                                    :fields="tables.clients_data.fields"
                                    :columnFilterValue.sync="
                                        tables.clients_data.columnFilterValue
                                    "
                                    @update:column-filter-value="updateData()"
                                    :items-per-page="tables.clients_data.rows"
                                    @pagination-change="itemPerPage"
                                    v-bind="tables.clients_data"
                                >
                                    <template #over-table>
                                        <CContainer :fluid="true">
                                            <CRow alignHorizontal="start">
                                                <CDropdown
                                                    color="primary"
                                                    :toggler-text="
                                                        $t('actions')
                                                    "
                                                    class="m-2"
                                                    :disabled="
                                                        tables.clients_data
                                                            .itemSelected ===
                                                        null
                                                    "
                                                >
                                                    <CDropdownItem
                                                        tag="div"
                                                        :title="
                                                            $t(
                                                                'set_configuration'
                                                            )
                                                        "
                                                        @click="
                                                            $router.push({
                                                                name: 'update_client',
                                                                params: {
                                                                    uuid: tables
                                                                        .clients_data
                                                                        .itemSelected
                                                                        .uuid,
                                                                },
                                                            })
                                                        "
                                                    >
                                                        {{ $t("edit_client") }}
                                                    </CDropdownItem>
                                                    <CDropdownItem
                                                        tag="div"
                                                        :title="$t('delete')"
                                                        @click="
                                                            deleteItem(
                                                                tables
                                                                    .clients_data
                                                                    .itemSelected
                                                            )
                                                        "
                                                    >
                                                        {{
                                                            $t("delete_client")
                                                        }}
                                                    </CDropdownItem>
                                                </CDropdown>
                                            </CRow>
                                        </CContainer>
                                    </template>
                                    <template #_selected="{ item }">
                                        <CInputRadio
                                            name="_selected"
                                            :checked="
                                                item ===
                                                tables.clients_data.itemSelected
                                            "
                                            @update:checked="
                                                selectItemTable(
                                                    'clients_data',
                                                    item
                                                )
                                            "
                                        />
                                    </template>
                                    <template #created_at="{ item }">
                                        <span>{{
                                            item.created_at.split(" ")[0]
                                        }}</span>
                                    </template>
                                    <template #under-table>
                                        <div class="d-flex justify-content-end">
                                            <ButtonExport
                                                endPoint="/clients.api"
                                                :table="tables.clients_data"
                                            />
                                        </div>
                                    </template>
                                </CCTable>
                            </CCardBody>
                            <CCardFooter>
                                <div class="position-relative">
                                    <CPagination
                                        @update:activePage="updatePagination"
                                        :activePage="tables.clients_data.page"
                                        :pages="tables.clients_data.total_pages"
                                        align="center"
                                    />
                                    <CElementCover
                                        :opacity="0.8"
                                        class="bg-trasparent"
                                        v-if="tables.clients_data.loading"
                                    />
                                </div>
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
            <NoItemsContainer
                v-show="
                    !hasItemsInTable({
                        tableName: 'clients_data',
                    })
                "
            >
                <template #title>
                    {{ $t("Create your first client") }}
                </template>
                <template #description>
                    {{ $t("Add a client to send your leads report to") }}
                </template>
                <template #redirect>
                    <ButtonCreate
                        :title="$t('Create my first client')"
                        @click="
                            $router.push({
                                name: 'create_client',
                            })
                        "
                    >
                        {{ $t("Create my first client") }}
                    </ButtonCreate>
                </template>
                <template #cleanFilter>
                    <CButton
                        color="primary"
                        class="button"
                        v-show="
                            hasFiltersInTable({
                                tableName: 'clients_data',
                            })
                        "
                        @click="
                            cleanFiltersAdvance('clients_data'), updateData()
                        "
                    >
                        <span class="button__icon">
                            <CIcon :content="$options.icons.eraser" />
                        </span>
                        <span class="button__text">
                            {{ $t("Clean filters") }}
                        </span>
                    </CButton>
                </template>
            </NoItemsContainer>
        </CCardBody>
    </CCard>
</template>

<script>
import TitlePage from "£lement/titlePage";
import FilterDate from "~/components/FilterDate";
import ButtonCreate from "~/components/ButtonCreate";
import TableSettings from "£lement/TableSettings";
import ButtonExport from "~/components/ButtonExport";
import FilterFields from "~/components/FilterFields";
import NoItemsContainer from "~/components/NoItemsContainer";
import CCTable from "~/components/CCTable";

import {
    cilPlus,
    cilSettings,
    cilPencil,
    cilTrash,
    cilUser,
} from "@coreui/icons";
import { mapGetters } from "vuex";
import pageMixin from "~/mixins/page.js";
import tableMixin from "~/mixins/table.js";
import { eraser } from "~/assets/icons/js/eraser";

export default {
    name: "ClientsDataPage",
    middleware: ["auth", "page"],
    mixins: [pageMixin, tableMixin],
    components: {
        TitlePage,
        FilterDate,
        ButtonCreate,
        TableSettings,
        ButtonExport,
        FilterFields,
        NoItemsContainer,
        CCTable,
    },
    icons: {
        cilPlus,
        cilSettings,
        cilPencil,
        cilTrash,
        cilUser,
        eraser,
    },
    data() {
        return {
            tables: {
                clients_data: {
                    fields: [
                        {
                            key: "_selected",
                            label: "",
                            sortable: false,
                            fixed: true,
                            filter: false,
                            _filter: false,
                        },
                        {
                            key: "id",
                            label: "#",
                            sortable: false,
                            _style: "width:7%",
                            fixed: true,
                            filter: true,
                            _filter: true,
                        },
                        {
                            key: "uuid",
                            label: "uuid",
                            sortable: false,
                            active: false,
                            _active: false,
                            fixed: true,
                            filter: true,
                            _filter: true,
                        },
                        {
                            key: "name",
                            label: "Name",
                            sorter: true,
                            filter: true,
                            _filter: true,
                        },
                        {
                            key: "type",
                            label: "Type",
                            sorter: true,
                            filter: false,
                            _filter: {
                                active: false,
                                value: null,
                                condition: "is_equal_to",
                                type: "select",
                                options: [
                                    {
                                        value: "client",
                                        label: this.$t("client"),
                                    },
                                    {
                                        value: "sponsor",
                                        label: this.$t("sponsor"),
                                    },
                                    {
                                        value: "coregister",
                                        label: this.$t("coregister"),
                                    },
                                ],
                            },
                        },
                        {
                            key: "country_id",
                            label: "Country",
                            sorter: true,
                            filter: false,
                            _filter: false,
                        },
                        {
                            key: "created_at",
                            label: "Created At",
                            sorter: true,
                            filter: false,
                            _filter: false,
                        },
                    ],
                    items: [],
                    order: "desc",
                    rows: 10,
                    page: 1,
                    total_pages: 1,
                    loading: true,
                    pagination: true,
                    sorter: true,
                    itemSelected: null,
                    allFields: [],
                    columnFilter: {
                        external: true,
                        lazy: true,
                    },
                    columnFilterValue: {},
                    itemsPerPageSelect: true,
                    loadQueryFromUrl: true,
                    size: "sm",
                },
            },
            modals: {
                delete: {
                    show: false,
                    item_selected: null,
                },
            },
        };
    },
    computed: {
        ...mapGetters({
            from: "filter/from",
            to: "filter/to",
        }),
    },
    methods: {
        async updateData() {
            await this.updateTable({
                tableName: "clients_data",
                url: "/clients.api",
            });

            this.tables.clients_data.itemSelected = null;

            this.loadLanguageInTable({
                tableName: "clients_data",
                fielLanguageName: "language_id",
            });
            this.loadCountryInTable({
                tableName: "clients_data",
                fielCountryName: "country_id",
            });

            this.$store.dispatch("page/updateLoading", {
                loading: false,
            });
        },
        async deleteItem(item) {
            try {
                await this.deleteData({
                    url: "/clients.api/" + item.uuid + "/delete",
                });
                this.updateData();
            } catch (error) {
                return;
            }
        },
    },
    beforeRouteUpdate(to, from, next) {
        this.resetFiltersInTable({
            tableName: "clients_data",
        })
        this.updateData();
        next(); // Continúa con la navegación
    },

    mounted() {
        this.updateData();
        this.loadLanguages();
        this.loadCountries();
    },
};
</script>

<style scoped lang="scss"></style>
